import React from "react";
import styled from "styled-components";
import Button from "../Button";
import { useNavigate } from "react-router-dom";
import { spinscale } from "../Keyframes";
import { useTranslation } from "react-i18next";

import { ReactComponent as EarthSvg } from "../../assets/earth.svg";
import { ReactComponent as StarsSvg } from "../../assets/stars.svg";
import { ReactComponent as SpaceOctopus } from "../../assets/space-octopus.svg";
import LogoImg from "../../assets/crab.png";

const Container = styled.div`
  background-image: linear-gradient(#060606, #08345c);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 100vh;
  width: 100vw;
  z-index: -10;
  padding: 2vh 2vw;
  box-sizing: border-box;
`;

const ButtonWrapper = styled.div`
  text-align: center;
  width: 100%;
`;

const Spacer = styled.div`
  height: 5vh;
`;

const Title = styled.h1`
  background-color: #ff8a00;
  font-family: "Freckle Face", cursive;
  font-style: normal;
  font-weight: normal;
  font-size: 8vh;
  text-align: center;
  line-height: 8vh;
  text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
  color: transparent;
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  margin-bottom: 0;
  position: relative;
  top: 10%;
  z-index: 5;

  @media (max-width: 480px) {
    font-size: 5vh;
    line-height: 6vh;
  }
`;

const Octopus = styled.div`
  position: absolute;
  top: 2vh;
  right: 2vw;
  width: 10vw;
  @media (max-width: 480px) {
    right: 10vw;
    width: 45vw;
  }
`;

const Earth = styled.div`
  position: absolute;
  bottom: 0;
  left: -15vw;
  overflow: hidden;
  @media (max-width: 480px) {
    height: 25vh;
  }
`;


const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap; /* allow wrapping on smaller screens */
  gap: 3vw; /* horizontal space between buttons */
  width: 90vw;
  margin-bottom: 2vh;
`;

const LogoStatic = styled.img`
  position: fixed;
  bottom: 5%;        /* distance from bottom of viewport */
  right: 5%;         /* distance from right of viewport */
  width: 10vw;       /* responsive width */
  height: auto;      /* maintain aspect ratio */
  z-index: 5;

  @media (max-width: 768px) {
    width: 15vw;
    bottom: 5%;
    right: 5%;
  }

  @media (max-width: 480px) {
    width: 20vw;
    bottom: 5%;
    right: 5%;
  }
`;

const Stars = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  overflow: hidden;
  animation: ${spinscale} 4s linear infinite alternate;
`;

const GameLocationScreen = (props) => {
  const { t } = useTranslation(); 
  const navigate = useNavigate();
  const isMobileScreen = window.matchMedia("screen and (max-width: 768px)").matches;

  const startGame = (game) => {
    props.setGame(game);
    navigate(game);
  };

  return (
    <Container>
      <Title>{t('gameLocation.title')}</Title>

      <Octopus>
        <SpaceOctopus />
      </Octopus>

      <Stars>
        <StarsSvg />
      </Stars>

      <Earth>
        <EarthSvg />
      </Earth>

      <ButtonWrapper>
        <ButtonContainer>
          <Button
            primaryR
            type="button"
            label={t('gameLocation.home')}
            handleClick={() => startGame("/waste-sorting?type=home")}
          />
          <Button
            type="button"
            handleClick={() => startGame("/waste-sorting?type=school")}
            label={t('gameLocation.school')}
          />
          <Button
            primaryC
            type="button"
            handleClick={() => startGame("/waste-sorting?type=park")}
            label={t('gameLocation.park')}
          />
        </ButtonContainer>
      </ButtonWrapper>
      <LogoStatic src={LogoImg} alt="Mascot" /> 
      <Spacer />
    </Container>
  );
};

export default GameLocationScreen;
